module.exports = __webpack_public_path__ + "img/favicon.6a347940.png";